<div class="title-block">
  <h1 class="title">{{ title() }}</h1>
  <p class="divider" aria-hidden="true">◆</p>
  @if (lede(); as lede) {
    <p class="lede">{{ lede }}</p>
  }
</div>
